import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { EmptyState } from '../components/states.js';
import { Button, PageHeader } from '../components/ui.js';

/*
 * Obrazovky, ktore este nemaju obsah.
 *
 * Zamerne hovoria, PRECO su prazdne a kde je zatial nahrada - prazdna
 * stranka bez vysvetlenia vyzera ako chyba.
 */

export function NotFound(): ReactNode {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Stránka sa nenašla" />
      <EmptyState
        title="Taká stránka tu nie je"
        detail="Skontroluj adresu v prehliadači, alebo sa vráť na prehľad."
        action={
          <Link to="/">
            <Button variant="primary">Späť na prehľad</Button>
          </Link>
        }
      />
    </div>
  );
}
